module.exports = __webpack_public_path__ + "static/trans-101-89cb336bb4518157c081289a467e6bad.jpg";